<template>
  <div class="color-container col-12 pb-3">
    <ValidationObserver ref="observer" novalidate>
      <div class="col-12 pb-0 mb-0">
        <div class="row pt-4 pb-2 pl-4 pr-4 reason-divider">
          <span class="dot text-center pl-1">
            <i class="fas fa-file-alt" />
          </span>
          <label for class="d-block bold text-left">
            Razón para {{ reasonTitle }}
          </label>
        </div>
        <div class="row m-0 p-4 main-content text-center">
          <div
            v-if="
              ((oldReferralStatus == referralStatusEnum.AprobadoEnRempro ||
                oldReferralStatus ==
                  referralStatusEnum.Referido_a_Remedio_Provisional) &&
                referralStatus == referralStatusEnum.Aprobado) ||
                referralStatus != referralStatusEnum.Aprobado
            "
            class="row w-100"
          >
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100 text-left"
              name="tipyDropdown"
              rules="required"
            >
              <label for class="d-block bold text-left">Tipo:</label>
              <CustomDropDown
                id="tipyDropdown"
                v-model="selectedReasonType"
                :error="errors[0]"
                :custom-error-msg="errorMsgs.type"
                placeholder="Seleccione"
                fieldkey="id"
                fieldname="name"
                :options="reasonTypes"
                :clearable="false"
              />
            </ValidationProvider>
          </div>
          <div class="row w-100">
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100 text-left info"
              name="Comentario"
              rules="required"
            >
              <CustomTextArea
                id="comment"
                v-model="reasonComment"
                :rows="1"
                label="Comentario:"
                :maxlength="500"
                :error="errors[0]"
                :custom-error-msg="errorMsgs.comment"
                name="comment"
              />
            </ValidationProvider>
          </div>
          <div class="row w-100 mt-2">
            <label for class="d-block bold text-left">Documento:</label>
              <CustomFileInput
                ref="fileUpload"
                class="w-100 text-left info"
                v-model="document"
                display-style="normal"
                :accept="'.pdf'"
                :disabled="false"
                :name ="document"
              />
          </div>
        </div>
        <div class="d-flex flex-row-reverse bd-highlight w-100 mb-2 actions">
          <div class="mx-0 bd-highlight ml-2">
            <ActionButton variant="success" @click="save">
              Guardar
            </ActionButton>
          </div>
          <div class="mx-0 bd-highlight ml-2">
            <ActionButton
              id="modal-btn-cancelar"
              variant="outline-danger"
              i="fas fa-times-circle"
              @click="cancel"
            >
              Cancelar
            </ActionButton>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton';
import resourcesService from '@/services/resources.js';
import alert from '@/mixin/alert.mixin';
import rpStatuses from '@/utils/constants/rp/rpStatuses';
import CustomFileInput from '@/components/common/CustomFileInput';
import objectToFormData from "object-to-formdata";
export default {
  name: 'EvaluationReasons',
  components: {
    CustomDropDown,
    CustomTextArea,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomFileInput
  },
  mixins: [alert],
  props: {
    referralStatus: {
      type: Number,
      required: true,
    },
    oldReferralStatus: {
      type: Number,
      required: true,
    },
    studentReferralId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedReasonType: null,
      reasonComment: null,
      reasonTypes: [],
      showReaseonDropDown: true,
      errorMsgs: {
        type: 'Favor seleccionar el tipo de razón.',
        comment: 'Campo Requerido.',
      },
      resources: [],
      document:null,
      referralStatusEnum: rpStatuses,
    };
  },
  computed: {
    reasonTitle() {
      switch (this.referralStatus) {
        case this.referralStatusEnum.Aprobado:
          return 'Aprobado';
        case this.referralStatusEnum.Denegado:
          return 'Devolver Referido a la Escuela';
        case this.referralStatusEnum.Inactivo:
          return 'Inactivo';
        default:
          return '';
      }
    },
  },
  watch: {
    referralStatus: function(newVal) {
      if (newVal) {
        this.loadReasons();
      }
    },
  },
  async mounted() {
    await this.loadReasons();
    await this.loadResources();
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R90013',
        'R03200109',
      ]);
    },
    async loadReasons() {
      let url = '';
      if (
        (this.oldReferralStatus == this.referralStatusEnum.AprobadoEnRempro ||
          this.oldReferralStatus ==
            this.referralStatusEnum.Referido_a_Remedio_Provisional) &&
        this.referralStatus == this.referralStatusEnum.Aprobado
      ) {
        url =
          'api/studentevaluation/referralActionReasonsByStatusId?referralStatusId=' +
          this.oldReferralStatus;
      } else {
        url =
          'api/studentevaluation/referralActionReasonsByStatusId?referralStatusId=' +
          this.referralStatus;
      }

      await this.$ApiGet(url) // Usar endpoint de reasons cuando lo tengamos
        .then((res) => {
          this.reasonTypes = res.data ? res.data : [];
          this.reasonComment = '';
          if (this.reasonTypes.length == 1) {
            this.selectedReasonType = this.reasonTypes[0];
          }
        })
        .catch((err) => {
          this.ShowToast('', err.message, 'error');
        });
    },
    cancel() {
      this.$emit('cancel');
    },
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor verificar y completar la información solicitada.',
          // this.resources["R03200110"],
          this.resources['R90013']
        );
        return;
      }
      let selectedReasonId;
      if (this.referralStatus == this.referralStatusEnum.Aprobado) {
        selectedReasonId = null;
      } else {
        selectedReasonId = this.selectedReasonType.id;
      }
      let model = {
        Id: selectedReasonId,
        Comment: this.reasonComment,
        ReferralStatusId: this.referralStatus,
        Document: this.document,
        StudentReferralId: this.studentReferralId,
      };
      const formData = objectToFormData(model, { indices: true });
        formData.append(`document`, this.document);
      this.$ApiPost(`api/studentevaluation/saveReferralStatusReason`, formData)
        .then(() => {
          this.$emit(
            'changestatus',
            this.studentReferralId,
            this.referralStatus
          );
          this.ShowToast(
            'Completado',
            'Su información ha sido completada exitosamente.',
            'success'
          );
          this.cancel();
        })
        .catch((err) => {
          if (err && err.response && err.response.data)
            this.ShowToast(err.response.data.message, '', 'error');
          else this.ShowToast(err.message, '', 'error');
        });
    },
  },
};
</script>

<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>

<style scoped>
:root {
  --bg-eva-color: #f5eee9;
}
.color-container {
  background-color: #f5eee9;
  border-radius: 5px;
  opacity: 1;
}
#modal-btn-cancelar {
  background-color: var(--bg-eva-color);
}
#modal-btn-cancelar.outline-danger:hover {
  background-color: #c9545e;
  color: white;
}
.panel-row-without-selector {
  background: var(--bg-eva-color) !important;
}

.reason-divider {
  border-bottom: 1px solid white;
}
.dot {
  width: 24px;
  height: 24px;
  color: #ff7058;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 1px;
  padding-right: 4px;
  margin-right: 5px;
}

.info >>> textarea {
  min-height: 38px;
}
</style>
